module.exports = __webpack_public_path__ + "img/华北电力大学.7967fc22.png";